import {useTableContext} from '../TableContext.jsx'
import TopButton from './TopButton.jsx'

const ButtonDeleteRows = ({
    children = '删除',
    beforeDelete = async (table, keys) => keys,
    ...props
}) => {
    const table = useTableContext()

    const handleClick = async () => {
        const keys = await beforeDelete(
            table, table.rowSelection?.selectedRowKeys
        )

        if (keys) {
            table.deleteRows(keys)
        }
    }

    return (
        <TopButton
            minRows={1}
            onClick={handleClick}
            {...props}
        >{children}</TopButton>
    )
}

export default ButtonDeleteRows
